<template>
    <v-dialog v-model="mostra" max-width="360" v-bind="$attrs">
        <template #activator="scope">
            <slot name="activator" v-bind="scope" />
        </template>
        <v-card>
            <v-card-title class="text-h6">
                Deseja recusar os termos?
            </v-card-title>

            <v-card-text>
                <div>Todos os seus dados serão permanentemente deletados.</div>
                <v-checkbox color="error" v-model="termoRecusado">
                    <template v-slot:label>
                        <v-label :class="[ termoRecusado ? 'error--text' : undefined ]">
                            Estou ciente e desejo prosseguir
                        </v-label>
                    </template>
                </v-checkbox>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    text
                    color="primary"
                    @click="cancelar"
                >
                    Voltar
                </v-btn>
                <v-spacer />
                <v-btn
                    text
                    color="error"
                    @click="confirmar"
                    :disabled="!termoRecusado"
                >
                    Prosseguir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
    onConfirmar?: () => unknown,
    onCancelar?: () => unknown,
}>()

const termoRecusado = ref(false)
const mostra = ref(false)

watch(mostra, () => {
    if (mostra) termoRecusado.value = false
})

const confirmar = () => {
    mostra.value = false
    props.onConfirmar?.()
}

const cancelar = () => {
    mostra.value = false
    props.onCancelar?.()
}
</script>
